import {AngularJsMaterialModuleName, UtilsModuleName} from "./names/requiredModulesNames";
import {NOTIFICATIONS_SERVICE} from "./ToastNotificationService";
import angular from 'angular';
import {HttpResponseServiceName, ToastNotificationServiceName} from "./names/serviceNames";
import {PercentageFilter} from "./filter/PercentageFilter";
import {ElementHeightCallbackDirective} from "./directives/element-height-callback.directive";
import {CustomOnChangeDirective} from "./directives/file-onchange.directive";
import {HttpResponseService} from "./HttpResponseService";
import {IframeOnloadDirective} from "modules/utils/directives/iframe-onload.directive";

export const UTILS_MODULE = angular.module(UtilsModuleName, [AngularJsMaterialModuleName])
    .filter('percentage', PercentageFilter)
    .directive('customOnChange', CustomOnChangeDirective)
    .directive('iframeOnload', IframeOnloadDirective)
    .directive('elementHeightCallback', ElementHeightCallbackDirective)
    .service(ToastNotificationServiceName, NOTIFICATIONS_SERVICE)
    .service(HttpResponseServiceName, HttpResponseService.instance)